import { useEffect, useRef } from "react";
import { useNotifications } from "./useNotifications";
export const useAutoreloadNotifications = (refreshInterval) => {
    const { updateNotifications, resetInterval } = useNotifications();
    const timeout = useRef(0);
    useEffect(() => void updateNotifications(), []);
    useEffect(() => {
        if (resetInterval) {
            clearTimeout(timeout.current);
            timeout.current = window.setTimeout(() => updateNotifications(), refreshInterval);
        }
        return () => window.clearTimeout(timeout.current);
    }, [resetInterval]);
};
